import styled from 'styled-components';

export const MoreInfoBoxWrapper = styled.div`
  flex: initial !important;
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: -20px;
  margin-top: 24px;
  overflow: hidden;
  line-height: 1.5;
`;

export const ToggleMoreInfo = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  position: relative;
  padding-top: 22px;
  justify-content: space-between;
  border-top: 1px solid #d7dada;
  padding-right: 10px;
`;

export const ControlsBox = styled.div<{ isOpen: boolean; descriptionHeight: number }>`
  overflow: visible;
  max-height: 0px;
  width: 100%;
  transition: 0.5s;

  ${({ isOpen, descriptionHeight }) =>
    isOpen &&
    `
    max-height: ${descriptionHeight}px;
  `}
`;

export const ControlsWrapper = styled.div<{ isOpen: boolean }>`
  padding-bottom: 20px;
  opacity: 0;
  transition: 0.5s;
  transition-delay: 0s;

  ${({ isOpen }) =>
    isOpen &&
    `
    opacity: 1;
    transition-delay: 0.3s;
  `}
`;
